import { writable } from 'svelte/store';
export const hoverState = writable(false);
export const screenWidth = writable(0);
export const selectedShapeIndex = writable(-1);
export const hoveredXpos = writable(0);
export const hoveredYpos = writable(0);
export const originHoveredXpos = writable(0);
export const originHoveredYpos = writable(0);
